"use client";

import { SERVICE_ITEMS } from "@/lib/constants";
import {
  EXPERTISE_LABELS,
  EXPERTISE_ORDER,
} from "@/lib/config/services.config";

export default function ServiceMenu() {
  return (
    <section className="py-32">
      <div className="grid md:grid-cols-12 gap-8 items-center">
        {/* Title */}
        <div className="md:col-span-4">
          <h2 className="text-3xl font-medium">Services Menu</h2>
        </div>

        {/* Description */}
        <div className="md:col-span-8">
          <p className="text-text-muted-light dark:text-text-muted-dark text-lg">
            If you&rsquo;re looking for something specific, this is the full
            index of what we do across strategy, design, development, and brand.
            And yes, Google, please index this too.
          </p>
        </div>

        {/* Service Lists */}
        <div className="md:col-span-12 grid md:grid-cols-4 gap-8 mt-16">
          {EXPERTISE_ORDER.map((category) => (
            <div key={category}>
              <h3 className="mb-4 font-medium">{EXPERTISE_LABELS[category]}</h3>
              <ul className="space-y-2 text-text-muted-light dark:text-text-muted-dark">
                {SERVICE_ITEMS[category].map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
